module.exports = __webpack_public_path__ + "img/41.34a8d7f0.jpg";